import { IonSpinner } from "@ionic/react";
import { SessionView } from "admin/src/server/mappers/session/session";

import { surveyPreviewExpressions } from "admin/src/ui/components/surveyJS/preview/surveyPreviewExpressions";
import LoadingPage from "components/common/LoadingPage";
import PageComponent from "components/common/PageComponent";
import useDeviceInfo from "hooks/useDeviceInfo";
import useSession from "hooks/useSession";
import { Suspense, lazy, useEffect } from "react";
import { useHistory } from "react-router";
import { ENV } from "../appConstants/env";
const NewProfilePage = () => {
  const LazyLoadedSurveyPreview = lazy(() =>
    import("admin/src/ui/components/surveyJS/preview/SurveyPreview").then(
      (module) => ({
        default: module.SurveyPreview,
      }),
    ),
  );

  const history = useHistory();
  const session = useSession();
  const device = useDeviceInfo();

  useEffect(() => {
    if (session.profile) {
      history.replace("/overview");
    }
  }, [session.profile]);

  return (
    <PageComponent>
      {device.isNativeApp && (
        <PageComponent.Header showBackButton={true}></PageComponent.Header>
      )}
      <PageComponent.Content>
        <Suspense fallback={<LoadingPage />}>
          <LazyLoadedSurveyPreview
            baseUrl={ENV.REACT_APP_PILLAR_API_URL}
            formDesign={session.society?.profileForm!.formDesign!}
            session={session as SessionView}
            spinner={<IonSpinner />}
            afterWorkflowInstanceStopped={async () => {
              await session.refreshSession();
              history.push("/login");
            }}
            {...surveyPreviewExpressions}
          />
        </Suspense>
      </PageComponent.Content>
    </PageComponent>
  );
};

export default NewProfilePage;
